module.exports = __webpack_public_path__ + "img/icon1.a60518b0.png";